import { AxiosError } from 'axios';

export const handleAxiosError = (error: AxiosError) =>
  Promise.reject(error.response?.data);
